/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
// import AssetModel from 'cio/models/asset';
import UserModel from 'cio/models/user';
import FormValidations from 'cio/utils/form-validations';
import UserEmailValidations from 'cio/utils/validations/user-email';

import { task } from 'ember-concurrency';

interface SettingsTeamSetEmailFormArgs {
  user: UserModel;
  onSubmit: (user: UserModel, email: string, currentPassword: string) => unknown;
  onCancel: () => unknown;
  onSelectImage: (imagePath: string) => unknown;
}

export default class SettingsTeamSetEmailForm extends Component<SettingsTeamSetEmailFormArgs> {
  @tracked validations: FormValidations;
  @tracked formValues = {
    email: '',
    currentPassword: '',
  };

  @tracked emailTouched = false;
  @tracked currentPasswordTouched = false;

  user!: UserModel;

  submitTask = task(async (event: Event) => {
    event.preventDefault();

    await this.validations.validateModel();
    if (!this.validations.hasErrors) {
      await this.args.onSubmit(this.args.user, this.formValues.email, this.formValues.currentPassword);
    }
  });

  @action
  setCurrentPassword(password: string) {
    this.currentPasswordTouched = true;
    this.formValues.currentPassword = password.trim();
    this.validations.validateAttribute('currentPassword');
  }

  @action
  setEmail(email: string) {
    this.emailTouched = true;
    this.formValues.email = email.trim();
    this.validations.validateAttribute('email');
  }

  @action
  setFieldTouched(fieldName: string) {
    switch (fieldName) {
      case 'email':
        this.emailTouched = true;
        break;
      case 'currentPassword':
        this.currentPasswordTouched = true;
        break;
    }

    this.validations.validateAttribute(`${fieldName}`);
  }

  @action
  cancel() {
    this.args.onCancel();
  }

  get isSubmitDisabled() {
    return this.submitTask.isRunning || this.validations.hasErrors || !this.emailTouched;
  }

  constructor(owner: unknown, args: SettingsTeamSetEmailFormArgs) {
    super(owner, args);

    this.validations = FormValidations.create({
      validations: UserEmailValidations,
      context: this,
      modelKey: 'formValues',
    });
  }
}
